module.exports = __webpack_public_path__ + "img/cup.350644b7.svg";